import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../stores';
import { Helper } from '../../../Helper';

import TranslationService from '../../../services/TranslationService';
import { LocalizationService } from '../../../services/LocalizationService';

import { IAMessageBar } from '../../messageBar/MessageBar';
import * as styles from './TranslationPanel.css';

export interface IProps {
  navigatorStore?: NavigatorStore;
  isShowing?: boolean;
}

export interface IState {
  isTranslating: boolean,
  selectedLanguage: { title: string, id: string, name: string }
  textControls: Array<{ id: string, innerHtml: string }>
  pageTitle: string
  topicHeader: string
  originalContent: boolean,
  isInEditMode: boolean;
}

@inject('navigatorStore')
@observer
export default class TranslationPanel extends React.Component<IProps, IState> {

  private readonly translationService: TranslationService = new TranslationService();
  private readonly localizationService: LocalizationService = new LocalizationService();
  private languages: any;

  constructor(props) {
    super(props);
    this.state = {
      isTranslating: false,
      selectedLanguage: null,
      textControls: [],
      pageTitle: "",
      topicHeader: "",
      originalContent: true,
      isInEditMode: false
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
    this.props.navigatorStore.isNavigatedEventRegistered = false;
  }

  public render() {
    this.languages = [...Helper.getLanguages(this.localizationService)];
    let top = 40;
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") != undefined && document.getElementById("IA_navigator_vertical_menu") == undefined) {
      top = 88;
    }
    let options: JSX.Element[] = [];
    this.languages.forEach((option: { "id": string, "title": string }) => {
      options.push(
        <li
          role="presentation"
          id={option.id}
        >
          <button
            role="menuitem"
            tabIndex={0}
            value={option.id}
            onClick={() => {
              let selectedOption = option.id;
              this.props.navigatorStore.selectedTranslationPage = false;
              if ((this.props.navigatorStore.isNavigatedEventRegistered || selectedOption !== this.state.selectedLanguage?.id) && selectedOption.length > 0) {
                this.translatePage(selectedOption);
              }
            }}
          >{option.title}</button>
        </li>
      );
    })
    return (
      <>
        {!this.state.originalContent && !this.props.navigatorStore.isNavigatedEventRegistered && !this.state.isTranslating && this.state.textControls.length > 0 && <IAMessageBar
          type="information"
          content={`${this.localizationService.strings.Panel_NavigatorBar_TranslatedMessage} ${this.state.selectedLanguage?.title}`}
          icon="Info"
          showIcon={true}
          showCloseButton={false}
          highlightColor={this.props.navigatorStore.highlightColor}
          dismissContentMessage={this.localizationService.strings.Panel_NavigatorBar_DismissTranslation}
          onDismiss={() => {
            this.setOriginalContent();
          }}
          style={{
            position: "fixed",
            zIndex: 2000000,
            left: this.props.navigatorStore.isMobile ? 0 : "calc(50vw - 250px)",
            width: this.props.navigatorStore.isMobile ? window.innerWidth : "500px",
            borderRadius: 5,
            padding: "5px 5px",
            marginBottom: 20
          }}
        />}
        {this.state.isInEditMode && <IAMessageBar
          type="information"
          content={`${this.localizationService.strings.Panel_NavigatorBar_TranslationPanelEditMode}`}
          icon="Info"
          showIcon={true}
          showCloseButton={true}
          onDismiss={() => {
            this.setState({ isInEditMode: false });
          }}
          style={{
            position: "fixed",
            zIndex: 2000000,
            left: this.props.navigatorStore.isMobile ? 0 : "calc(50vw - 250px)",
            width: this.props.navigatorStore.isMobile ? window.innerWidth : "500px",
            borderRadius: 5,
            padding: "5px 5px",
            marginBottom: 20
          }}
        />}
        {!!this.props.navigatorStore.selectedTranslationPage && <div role="menu" style={{ zIndex: 10000, top: top, left: this.props.navigatorStore.translationIconRight - 180 }} className={styles.IA_translationPanel}><ul>
          {options}
        </ul> </div>}

      </>
    );
  }

  private translatePage(lang: string) {
    if (window.location.href.indexOf("Mode=Edit") !== -1) {
      this.setState({ isInEditMode: true });
      return;
    }
    this.props.navigatorStore.isNavigatedEventRegistered = false;
    this.setState({ isTranslating: true, selectedLanguage: this.languages.find(x => x.id == lang) });

    this.props.navigatorStore.isTranslating = true;
    this.props.navigatorStore.selectedTranslationPage = false;
    this.forceUpdate();

    this.translateTextControls(lang).then(() => {
      this.translatePageTitle(lang, this.state.pageTitle).then(() => {
        if (this.state.topicHeader && this.state.topicHeader.length > 0) {
          this.translateTopicHeader(lang).then(() => {
            this.setState({ isTranslating: false, originalContent: false });
            this.props.navigatorStore.isTranslating = false;
            this.forceUpdate();
          })
        } else {
          this.setState({ isTranslating: false, originalContent: false });
          this.props.navigatorStore.isTranslating = false;
          this.forceUpdate();
        }
      })
    })

  }
  private async translateTextControls(lang: string) {
    try {
      let pageInfo = await this.props.navigatorStore.getPageInformation();
      this.setState({ pageTitle: pageInfo.pageTitle, topicHeader: pageInfo.topicHeader });
      let controls = pageInfo.textControls;
      for (let control of controls) {
        await this.translateControl(control, lang);
      }
    } catch (error) {
      console.log(error);
    }
  }

  private setOriginalContent() {
    this.state.textControls.forEach((control) => {
      try {
        let webpart = document.querySelector(`[data-sp-feature-instance-id='${control.id}']`);
        let element = webpart?.firstChild as Element;
        element.innerHTML = control.innerHtml;
      } catch (error) { }
    })
    const pageTitleElement: Element = document.querySelector("div[data-automation-id='TitleTextId']");
    if (pageTitleElement !== null) {
      pageTitleElement.textContent = this.state.pageTitle;
    }
    const topicHeaderElement: Element = document.querySelector("div[data-automation-id='topicHeader']");
    if (this.state.topicHeader && topicHeaderElement !== null && topicHeaderElement.childNodes?.length > 0) {
      topicHeaderElement.childNodes[0].textContent = this.state.topicHeader;
    }
    this.setState({ textControls: [], selectedLanguage: { title: "", id: "", name: "" }, originalContent: true });
  }

  private async translatePageTitle(lang: string, pageTitle: string) {
    try {
      const pageTitleElement: Element = document.querySelector("div[data-automation-id='TitleTextId']");
      if (pageTitle && pageTitleElement !== null) {
        let translation = await this.translationService.getTranslations(this.props.navigatorStore.environment, this.props.navigatorStore.token, this.props.navigatorStore.tenant.replace(".sharepoint.com", ""), "test", "test", "test", pageTitle, lang);
        pageTitleElement.textContent = translation[2];
      }
    } catch (error) {
      console.log(error);
    }

  }

  private async translateTopicHeader(lang: string) {
    try {
      const topicHeaderElement: Element = document.querySelector("div[data-automation-id='topicHeader']");
      if (this.state.topicHeader && topicHeaderElement !== null && topicHeaderElement.childNodes?.length > 0) {
        let translation = await this.translationService.getTranslations(this.props.navigatorStore.environment, this.props.navigatorStore.token, this.props.navigatorStore.tenant.replace(".sharepoint.com", ""), "test", "test", "test", this.state.topicHeader, lang);
        topicHeaderElement.childNodes[0].textContent = translation[2];
      }
    } catch (error) {
      console.log(error);
    }
  }

  private async translateControl(control: string, lang: string) {
    try {
      let webpart = document.querySelector(`[data-sp-feature-instance-id='${control}']`);
      let element = webpart?.firstChild as Element;
      let innerHtml = "";
      if (this.state.textControls.findIndex(x => x.id == control) != -1) {
        innerHtml = this.state.textControls.find(x => x.id == control).innerHtml;
      } else {
        innerHtml = element?.innerHTML;
        this.setState({ textControls: [...this.state.textControls, { id: control, innerHtml: element.innerHTML }] })
      }

      let translation = await this.translationService.getTranslations(this.props.navigatorStore.environment, this.props.navigatorStore.token, this.props.navigatorStore.tenant.replace(".sharepoint.com", ""), "test", "test", "test", innerHtml, lang);
      element.innerHTML = translation[2];

    } catch (error) {
      console.log(error);
    }
  }

}